<div [innerHTML]="value | safeHtml" class="html-template eidos-full-visible-text"></div>